module.exports = __webpack_public_path__ + "static/media/BarrelCutBottom.9173d6f1.png";